/*
 * File: ui-autofill.ts
 * File Created: 2024-02-01 08:50:11
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-06 05:44:09
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";

// @uiAutofill - Set the Form Input of browser auto fill. false to disable it.
// allow value: true | false | password | date

@UITag.set()
export class uiAutofill extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean, EUITagRuleType.String];
    allowNullRule: boolean = true; /// default: true

    /// set props :description
    parse(input: IUITagInput): IUITagResult | null {
        const parsed = this.parseRule(input);
        const rule = parsed == undefined ? true : parsed;

        let props: IUITagResult["props"];
        if (rule == true) {
            props = { autocomplete: "on" };
        } else if (rule === "password") {
            props = { autocomplete: "new-password" };
        } else if (rule === "date") {
            props = { autocomplete: "date" };
        } else {
            switch (input.meta.attr.type.name) {
                case "Date":
                // props = { autocomplete: "transaction-date" };
                // break;
                case "string":
                case "boolean":
                case "number":
                default:
                    props = { autocomplete: "off" };
                    break;
            }
        }

        /// normal case
        return { props };
    }
}
